<template>
      <div style="height: 32rem" class="flex items-center">
              <div class="shadow-lg mt-3 ml-3 p-6 bg-gray-50  w-2/4 h-full">

          <div class=" relative">

              <div class="text-center text-lg">{{reportContent.sub_title}}</div>

              <div class="m-2 text-base">
                  <span class=" text-gray-400">时间</span>
                  <span  class="pl-1">{{reportContent.oper_time}}</span>
              </div>
              <div class="m-2 text-base">
                  <span class=" text-gray-400">收银</span>
                  <span  class="pl-1">{{reportContent.oper_user_name}}</span>
              </div>
               <el-divider></el-divider>
              <div class="flex items-center">
                  <div class="m-2 text-base w-48">
                  <span class=" text-gray-400">售卡笔数</span>
                  <span  class="pl-5">{{reportContent.subject.skbs}}</span>
                  </div>

                   <div class="m-2 text-base">
                  <span class=" text-gray-400">售卡数量</span>
                  <span  class="pl-5">{{reportContent.subject.sksl}}</span>
                  </div>
              </div>
               <div class="flex items-center">
                  <div class="m-2 text-base w-48">
                  <span class=" text-gray-400">充值笔数</span>
                  <span  class="pl-5">{{reportContent.subject.czbs}}</span>
                  </div>

                   <div class="m-2 text-base">
                  <span class=" text-gray-400">充值金额</span>
                  <span  class="pl-5">{{reportContent.subject.czje}}</span>
                  </div>
              </div>
               <div class="flex items-center">
                  <div class="m-2 text-base w-48">
                  <span class=" text-gray-400">消费笔数</span>
                  <span  class="pl-5">{{reportContent.subject.xfbs}}</span>
                  </div>

                   <div class="m-2 text-base">
                  <span class=" text-gray-400">消费金额</span>
                  <span  class="pl-5">{{reportContent.subject.xfje}}</span>
                  </div>
              </div>
               <div class="flex items-center">
                  <div class="m-2 text-base w-48">
                  <span class=" text-gray-400">充次笔数</span>
                  <span  class="pl-5">{{reportContent.subject.ccbs}}</span>
                  </div>

                   <div class="m-2 text-base">
                  <span class=" text-gray-400">充次金额</span>
                  <span  class="pl-5">{{reportContent.subject.ccje}}</span>
                  </div>
              </div>




              <div class="m-2 text-base">
                  <span class=" text-gray-400">收款合计</span>
                  <span  class="pl-5">{{reportContent.subject.skhj}}</span>
              </div>
              <div class="m-2 text-sm"  v-for="tag in reportContent.payment_list"
    :key="tag.keyname">
                  <span class=" text-gray-400 pl-9">{{tag.keyname}}</span>
                  <span  class="pl-5">{{tag.keyval}}</span>
              </div>
              

             

         



                    <div class="absolute cursor-pointer text-gray-700 top-0 right-0" @click="doPrint(reportContent.print_id)">
                    <i class="iconfont icon-dayin"></i>
                    <span class="pl-1">打印</span>
                    </div>

          </div>

        </div>
        <div class="shadow-lg mt-3 ml-3 p-6 bg-gray-50  w-2/4 h-full overflow-y-auto">
             
              
              <div class="m-2 text-base">
                  <span class=" text-gray-400">充值交易明细</span>
              </div>
              <div class="m-2 text-sm text-gray-500"  v-for="row in czList">
                  <span>卡号{{row.cardCode}}</span>
                  <span  class="pl-10">{{row.incomeAmount}}</span>
                  <span  class="pl-10">{{row.paymentName}}</span>
              </div>
                <div class="m-2 text-sm text-gray-500 text-center"  v-if="czList.length==0">
                    <span>暂无记录</span>
                </div>
              
  <el-divider></el-divider>
                 <div class="m-2 text-base">
                  <span class=" text-gray-400">消费交易明细</span>
                  
              </div>
              <div class="m-2 text-sm text-gray-500"  v-for="row in xfList">
                  <span>卡号{{row.cardCode}}</span>
                  <span  class="pl-10">{{row.consumeAmount}}</span>
              </div> 
               <div class="m-2 text-sm text-gray-500 text-center"  v-if="xfList.length==0">
                    <span>暂无记录</span>
                </div>
              <el-divider></el-divider>
                 <div class="m-2 text-base">
                  <span class=" text-gray-400">充次交易明细</span>
                  
              </div>

              <div class="m-2 text-sm text-gray-500"  v-for="row in ccList">
                  <span>卡号{{row.cardCode}}</span>
                  <div>
                        <span>收款明细</span>
                        <span  class="pl-2 text-xs"  v-for="pay in row.payList">{{pay.paymentName}}({{pay.amountVal}})</span>
                  </div>
                  <div>
                    <span>充次项目</span>
                    <span class="pl-2 text-xs" v-for="goods in row.itemList">{{goods.goodsName}}({{goods.num}}{{goods.unitName}})</span>
                  </div>
                   
              </div> 

 <div class="m-2 text-sm text-gray-500 text-center"  v-if="ccList.length==0">
                    <span>暂无记录</span>
                </div>
               <el-divider></el-divider>
                 <div class="m-2 text-base">
                  <span class=" text-gray-400">核销交易明细</span>
                  
              </div>
              <div class="m-2 text-sm text-gray-500"  v-for="row in hxList">
                  <span class=" text-xs">{{row.fromw==0?"卡号"+row.cardCode:"券号"+row.couponCode}}</span>
                  <span  class="pl-10 text-xs">{{row.couponName}}</span>
                  <span  class="pl-10">{{row.state==0?'核销':'已红冲'}}</span>
              </div> 
               <div class="m-2 text-sm text-gray-500 text-center"  v-if="hxList.length==0">
                    <span>暂无记录</span>
                </div>
                
                <el-divider></el-divider>
                 <div class="m-2 text-base">
                  <span class=" text-gray-400">售卡明细</span>
                  
              </div>
              <div class="m-2 text-sm text-gray-500"  v-for="row in skList">
                  <span>卡号{{row.cardCode}}</span>
                  <span  class="pl-10">{{row.cardTypeName}}</span>
              </div> 
                 <div class="m-2 text-sm text-gray-500 text-center"  v-if="skList.length==0">
                    <span>暂无记录</span>
                </div>
            
        </div>
      </div><!--div-->


</template>
<script>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { getReport01, printReport,getReport01Child } from '@/utils/report.js'
export default {
  setup () {
    const reportContent = ref({})
    const czList=ref([]);
    const xfList=ref([]);
    const ccList=ref([]);
    const hxList=ref([]);
        const skList=ref([]);
    getReport01((res) => {
      reportContent.value = res


       getReport01Child(1,res.print_id,(result) => {
           czList.value=result.rows;
       })
        getReport01Child(2,res.print_id,(result) => {
           xfList.value=result.rows;
       })
          getReport01Child(3,res.print_id,(result) => {
           ccList.value=result.rows;
       })
        getReport01Child(4,res.print_id,(result) => {
           hxList.value=result.rows;
       })
        getReport01Child(5,res.print_id,(result) => {
           skList.value=result.rows;
       })
    })
    const doPrint = (printID) => {
      printReport(printID, () => {
        ElMessage({
          showClose: true,
          message: '打印请求成功',
          type: 'success'
        })
      })
    }
   


    return {
      doPrint, reportContent,czList,xfList,ccList,hxList,skList
    }
  }
}
</script>
